exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.color_light{\n    background-color:#dcecf3;\n        margin:0rem 0.3rem;\n    border: 2px solid #c7ece2;\n    border-radius: 5px;\n    box-shadow: 0px 4px 4px rgba(148, 150, 151, 0.747);\n    padding: 5px 10px;\n}\n.textcolor{\n    color:black;\n    font-weight: bold;\n    font-family: 'Courier New', Courier, monospace;\n}\n    \n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46b7d334","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/common_components/singleBoxItem.vue
// module id = 2070
// module chunks = 0